module.exports = __webpack_public_path__ + "media/fr-4.ba88b5c1.mp3";